<template>
  <div id="academic_thought_leaders">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro">
      <usc-cta slot="cta" text="Meet your future mentors" url="https://www.marshall.usc.edu/faculty-research/faculty-directory"></usc-cta>
    </usc-intro>
    <div class="body gutter-lg mb">
      <h3>Accounting: Mingyi Hung</h3>
      <h4>Expertise</h4>
      <p>The role of accounting information in global markets</p>
      <h4>Select publications</h4>
      <p>Journal of Accounting and Economics, Journal of Accounting Research and Review of Accounting Studies</p>
      <h4>Select honors</h4>
      <p>Best Paper Award, European Accounting Association; Best Paper Prize, Journal of Accounting and Economics; USC Marshall Golden Apple Award; two research grants from Hong Kong University</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Communication: Robyn Walker</h3>
      <h4>Expertise</h4>
      <p>Communication and decision making in teams</p>
      <h4>Select publications</h4>
      <p>American Communication Journal; International Journal of Diversity in Organizations, Communities and Nations; International Journal of Knowledge, Culture and Change Management; and Business Communication Quarterly</p>
      <h4>Select honors</h4>
      <p>Editor, Journal of Business Communication; Mellon Fellow, USC; Peer Achievement Faculty Award, USC Student Senate Leadership Council; three-time recipient of both the USC Marshall School of Business Summer Research Grant and USC Undergraduate Research Grant</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Economics: Kevin Murphy</h3>
      <h4>Expertise</h4>
      <p>Executive compensation</p>
      <h4>Select publications</h4>
      <p>Journal of Accounting & Economics, Journal of Financial Economics, American Economic Review Papers and Proceedings and the University of Chicago Law Review</p>
      <h4>Additional professional service/experience</h4>
      <p>Associate Editor, Journal of Financial Economics and Journal of Corporate Finance (current); expert, U.S. Department of Treasury, Office of the Special Master for Executive Compensation (2009); Chairman, Academic Research Committee, American Compensation Association (1997-99)</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Entrepreneurship: Helena Yli-Renko</h3>
      <h4>Expertise</h4>
      <p>Growth and performance of young, technology-based firms; internationalization; and knowledge acquisition and social capital in interfirm relationships</p>
      <h4>Select publications</h4>
      <p>Journal of Marketing, International Business Review and Entrepreneurship and Regional Development</p>
      <h4>Select honors</h4>
      <p>Hills Award for Best Paper, American Marketing Association; Editorial Board member, Journal of Management Studies and International Journal of Technoentrepreneurship; 1996 Finnish Champion, Ladies’ Team Championship in Golf</p>
    </div>
    <div class="gutter-md">
      <div class="usc-carousel__header">
        <div class="usc-carousel__title">Our Thought Leaders</div>
        <div class="usc-carousel__nav">
          <div id="customize-controls" class="usc-carousel__controls">
            <button role="button" aria-label="Previous Image" @click="prevSlide" :disabled="prevDisabled" type="button" class="usc-carousel__button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13">
                <path fill="#231F20" d="M6 .5c0 .1 0 .2-.1.3L1.3 6.5l4.6 5.7c.1.3.1.6-.1.7-.3.1-.5.1-.7-.1L0 6.5 5.1.2c.2-.2.5-.2.7-.1.1.1.2.3.2.4z"/>
              </svg>
            </button>
            <button role="button" aria-label="Next Image" @click="nextSlide" :disabled="nextDisabled" type="button" class="usc-carousel__button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13">
                <path fill="#231F20" d="M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"/>
              </svg>
            </button>
          </div>
          <div class="usc-carousel__counter">
            {{this.slideIndex}} / {{this.totalSlides}}
          </div>
        </div>
      </div>
    </div>
    <div class="mb">
      <tiny-slider class="usc-carousel" :mouse-drag="false" :loop="false" items="1" :responsive="true" controlsContainer="#customize-controls">
        <div v-for="(slide, index) in this.slides" class="usc-carousel__slide">
          <!-- <div class="usc-carousel__img" :style="{ backgroundImage: 'url(' + slide.image + ')' }"></div> -->
          <div class="usc-carousel__outer">
            <img class="usc-carousel__inner" :src="slide.image" :alt="slide.alt || ''">
          </div>
        </div>
      </tiny-slider>
    </div>
    <div class="body gutter-lg mb">
      <h3>Finance: Fernando Zapatero</h3>
      <h4>Expertise</h4>
      <p>Mathematical and computational methods in asset pricing and corporate finance</p>
      <h4>Select publications</h4>
      <p>Journal of Accounting and Economics, Journal of Accounting Research and Review of Accounting Studies</p>
      <h4>Additional professional service/experience</h4>
      <p>Associate Editor, Annals of Finance, Journal of Economic Dynamics and Control, Mathematical Finance and Mathematics and Financial Economics (all current); Chair, Department of Finance and Business Economics, USC Marshall School of Business; referee, more than 25 journals</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Marketing: Valerie Folkes</h3>
      <h4>Expertise</h4>
      <p>Consumers’ responses to negative information and attributions for service and product performance</p>
      <h4>Select publications</h4>
      <p>Journal of Consumer Research, Psychology and Marketing and Journal of the Academy of Marketing Science</p>
      <h4>Select honors</h4>
      <p>Best Article on Services Award, American Marketing Association Services SIG; USC Mellon Award for Excellence in Marketing; Outstanding Reviewer Award, Journal of Consumer Research; President, Association for Consumer Research (2001)</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Operations: Amy Ward </h3>
      <h4>Expertise</h4>
      <p>Approximation and the control of stochastic systems; impact of customer impatience and abandonments on service system performance</p>
      <h4>Select publications</h4>
      <p>Journal of Applied Probability, Mathematics of Operation Research and Operations Research</p>
      <h4>Select honors</h4>
      <p>Operations Research Meritorious Service Award; co-advisor, 2006 Nicholson Student Paper Competition winner; Associate Editor, IIE Transactions, Service Operations Engineering Department</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Organizational Behavior: Nathanael Fast</h3>
      <h4>Expertise</h4>
      <p>The influence of power on people and their leadership effectiveness; the facilitation of the spread of culture</p>
      <h4>Select publications</h4>
      <p>Journal of Experimental Social Psychology and Psychological Science</p>
      <h4>Select honors</h4>
      <p>Best Papers Proceedings, Academy of Management; State Farm Doctoral Dissertation Award; All-American Scholar Athlete, Baseball; Graduate Dean’s Medal, College of Science and Mathematics, CSU-Fresno</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Statistics: Yingying Fan</h3>
      <h4>Expertise</h4>
      <p>High-dimensional statistical inference, classification and variable selection, nonparametric statistics and financial econometrics</p>
      <h4>Select publications</h4>
      <p>The Annals of Statistics, Journal of Econometrics and Journal of the American Statistical Association</p>
      <h4>Select honors</h4>
      <p>National Science Foundation Grant; Fellowship, Princeton University; Chair, IOM Department Statistics Seminar, USC Marshall School of Business (current); Zumberge Individual Award, USC James H. Zumberge Faculty Research and Innovation Fund</p>
    </div>
    <div class="body gutter-lg mb">
      <h3>Strategy: Peer Fiss</h3>
      <h4>Expertise</h4>
      <p>Diffusion of practices, framing and decoupling, symbolic management, corporate governance, strategic management, configurational theory, fuzzy set qualitative comparative analysis (fsQCA), set-theoretic methods in management and the social sciences</p>
      <h4>Select publications</h4>
      <p>Academy of Management Journal, Academy of Management Review and Strategic Management Journal</p>
      <h4>Select honors</h4>
      <p>Ascendant Scholar Award, Western Academy of Management; Award for Excellence in Research, USC Marshall School of Business; Fellow, Judge Business School, University of Cambridge</p>
    </div>
    <div class="gutter-md">
      <div class="usc-carousel__header">
        <div class="usc-carousel__title">Our Thought Leaders</div>
        <div class="usc-carousel__nav">
          <div id="customize-controls2" class="usc-carousel__controls">
            <button role="button" aria-label="Previous Image" @click="prevSlide2" :disabled="prevDisabled" type="button" class="usc-carousel__button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13">
                <path fill="#231F20" d="M6 .5c0 .1 0 .2-.1.3L1.3 6.5l4.6 5.7c.1.3.1.6-.1.7-.3.1-.5.1-.7-.1L0 6.5 5.1.2c.2-.2.5-.2.7-.1.1.1.2.3.2.4z"/>
              </svg>
            </button>
            <button role="button" aria-label="Next Image" @click="nextSlide2" :disabled="nextDisabled" type="button" class="usc-carousel__button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13">
                <path fill="#231F20" d="M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"/>
              </svg>
            </button>
          </div>
          <div class="usc-carousel__counter">
            {{this.slideIndex2}} / {{this.totalSlides2}}
          </div>
        </div>
      </div>
    </div>
    <div class="mb">
      <tiny-slider class="usc-carousel" :mouse-drag="false" :loop="false" items="1" :responsive="true" controlsContainer="#customize-controls2">
        <div v-for="(slide, index) in this.slides2" class="usc-carousel__slide">
          <div class="usc-carousel__outer">
            <img class="usc-carousel__inner" :src="slide.image" :alt="slide.alt || ''">
          </div>
        </div>
      </tiny-slider>
    </div>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import Cta from '@/components/Cta'
import VueTinySlider from 'vue-tiny-slider'

export default {
  name: 'UndergradAccounting',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': Cta,
    'tiny-slider': VueTinySlider
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Thought Leaders',
        loResSrc: './static/blur/Academics_ThoughtLeaders.jpg',
        hiResSrc: './static/Academics_ThoughtLeaders.jpg'
      },
      intro: [
        'Distinguished researchers fill the halls in every department at Marshall. Some of the thought leaders with whom you will work and learn include the following:'
      ],
      slideIndex: 1,
      vueTinySlider: VueTinySlider,
      prevDisabled: true,
      nextDisabled: false,
      slides: [
        {
          image: '/static/Academics_Thought_Leaders_2.jpg',
          alt: 'Woman speaking in front of a class',
          id: 0
        },
        {
          image: '/static/Academics_Thought_Leaders_3.jpg',
          alt: 'Man writing on whiteboard',
          id: 1
        }
      ],
      slideIndex2: 1,
      prevDisabled2: true,
      nextDisabled2: false,
      slides2: [
        {
          image: '/static/Academics_Thought_Leaders_5.jpg',
          alt: 'Woman sitting at a desk speaking to two younger people',
          id: 0
        },
        {
          image: '/static/Academics_Thought_Leaders_6.jpg',
          alt: 'Woman speaking in front of a class',
          id: 1
        }
      ]
    }
  },
  created () {
    this.$root.setPageHeader('Academics', 'Thought Leaders')
  },

  methods: {
    prevSlide () {
      if (this.slideIndex > 1) {
        this.slideIndex--
      } else {
        this.prevDisabled = true
      }
    },
    nextSlide () {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++
      } else {
        this.nextDisabled = true
      }
    },
    prevSlide2 () {
      if (this.slideIndex2 > 1) {
        this.slideIndex2--
      } else {
        this.prevDisabled2 = true
      }
    },
    nextSlide2 () {
      if (this.slideIndex2 < this.totalSlides2) {
        this.slideIndex2++
      } else {
        this.nextDisabled2 = true
      }
    }
  },

  computed: {
    totalSlides () {
      return this.slides.length
    },
    totalSlides2 () {
      return this.slides2.length
    }
  }
}
</script>

<style scoped lang="scss">
@import '~tiny-slider/src/tiny-slider';
</style>



// WEBPACK FOOTER //
// src/pages/academics/ThoughtLeaders.vue